var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5004 1.50276C1.94714 1.50276 1.50374 1.94616 1.50374 2.49943V17.9994C1.50374 18.5527 1.94714 18.9961 2.5004 18.9961H20.5004C21.0537 18.9961 21.4971 18.5527 21.4971 17.9994V4.99943C21.4971 4.44616 21.0537 4.00276 20.5004 4.00276H9.9129C9.51606 4.00276 9.13203 3.84288 8.85074 3.56159L6.93824 1.64909C6.84453 1.55538 6.71606 1.50276 6.5879 1.50276H2.5004ZM0.49707 2.49943C0.49707 1.39019 1.39117 0.496094 2.5004 0.496094H6.5879C6.98474 0.496094 7.36877 0.655975 7.65006 0.937267L9.56256 2.84977C9.65627 2.94347 9.78474 2.99609 9.9129 2.99609H20.5004C21.6096 2.99609 22.5037 3.89019 22.5037 4.99943V17.9994C22.5037 19.1087 21.6096 20.0028 20.5004 20.0028H2.5004C1.39117 20.0028 0.49707 19.1087 0.49707 17.9994V2.49943Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTree);
export default __webpack_public_path__ + "static/media/folder_tree.c3c1744a.svg";
export { ForwardRef as ReactComponent };